import Transitions from "Components/Transitions/Transitions";
import ChallengeCard from "./HomeComponents/ChallengeCard/ChallengeCard";
import TextSection from "./HomeComponents/TextSection/TextSection";
import SectionCard from "./HomeComponents/SectionCard/SectionCard";
import { Separator } from "Components/ui/separator";
import ProfitCard from "./HomeComponents/ProfitCard/ProfitCard";
import { ArrowRight, ArrowRightFromLine, Codepen } from "lucide-react";
import SecondSec from "./HomeComponents/SecondSec/SecondSec";
import FirstSec from "./HomeComponents/FirstSec/FirstSec";
import ThirdSec from "./HomeComponents/ThirdSec/ThirdSec";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useDispatch } from "react-redux";
import { getChallengesRequest } from "../../Redux/ChallengeMain/ChallengeMainActions";
import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

function Home() {
  const width = UseInnerWidth();

  const dispatch = useDispatch();
  const { getToken } = useAuth();

  useEffect(() => {
    dispatch(getChallengesRequest(getToken));
  }, []);

  return (
    <div className="w-full flex flex-col gap-4 ">
      {/* <div className="w-full mt-8 md:w-[40%] ">
            <ChallengeCard />
          </div> */}
      <div className={`flex-1 flex gap-4 sm:flex-row flex-col`}>
        <FirstSec />
        <SecondSec />
      </div>
      <ThirdSec />
    </div>
  );
}

export default Home;
